import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Icon from '@jetbrains/ring-ui/components/icon';
import info from '@jetbrains/icons/info';
import { PopupMessage } from '@common/popup-message';
import { Badge } from '@common/badge/general-badge/badge';
import styles from '@common/badge/specialized-badges/specialized-badges.css';
import { ConfigureAiPopupMessage } from './configure-ai-popup-message';
export function ConfigureAiBadge() {
    const badge = (_jsxs(Badge, { variant: Badge.variant.Filled, color: Badge.color.Warning, size: Badge.size.Md, className: classNames(styles.badge, styles.warning), children: ["Configuration required", _jsx(Icon, { className: styles.icon, glyph: info })] }));
    return (_jsx(PopupMessage, { title: "Configure AI Enterprise", anchor: badge, children: _jsx(ConfigureAiPopupMessage, {}) }));
}
